import Card from "components/card";
import BarChart from "components/charts/BarChart";
import { MdBarChart } from "react-icons/md";
import { useMemo } from "react";
import { useLanguage } from "context/LanguageContext";
import { useTheme } from "context/ThemeContext";
import ActionButton from "components/ui/ActionButton";
import {
  buildRevenueMonthlyChartData,
  buildRevenueMonthlyChartOptions,
} from "../variables/revenueChartOptions";

const RevenueCharts = () => {
  const { t, locale } = useLanguage();
  const { isDark } = useTheme();
  const chartData = useMemo(() => buildRevenueMonthlyChartData({ t }), [t]);
  const chartOptions = useMemo(
    () => buildRevenueMonthlyChartOptions({ t, locale, isDark }),
    [t, locale, isDark]
  );
  return (
    <Card extra="rounded-3xl bg-surface px-6 py-5">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-lg font-bold text-ink">
          {t("revenue.monthlyChartTitle")}
        </h2>
        <ActionButton variant="ghost" size="sm">
          <MdBarChart className="h-6 w-6" />
        </ActionButton>
      </div>
      <p className="text-xs text-ink-muted">
        {t("revenue.monthlyChartSubtitle")}
      </p>
      <div className="mt-4 h-[300px] w-full">
        <BarChart chartData={chartData} chartOptions={chartOptions} />
      </div>
    </Card>
  );
};

export default RevenueCharts;
